import React, { ComponentType } from 'react';
import Plx from 'react-plx';
import urlLanguageParse from 'presentation/utils/urlLanguageParse';
import withLanguage from 'presentation/hocs/withLanguage';

import { classNames } from './Parallax.stylesheet';
import { Layer } from './Layer';

interface OuterProps {
  layer: Layer;
}
interface InnerProps extends OuterProps {
  currentLanguage: string;
}

const getParallaxData = ({ layer }: { layer: Layer }) => {
  return [
    {
      start: 'self',
      // @TODO: this value will have to be determined by the ribbon's height.
      // We might have to use react-height here to help us.
      // ---
      // It is double the value of the viewheight to ensure that
      // it keeps performing the parallax scrolling past.
      // 200vh was an arbitary number. This will have to be tweaked with Matt's
      // consent.Make sure that when you tweak this number you also tweak
      // the height calc in the stylesheet
      duration: '200vh',
      properties: [
        {
          startValue: layer.fx.type === 'parallax' ? -400 : 0,
          endValue: 0,
          property: 'translateY',
        },
      ],
    },
  ];
};

export const Parallax = ({ layer, currentLanguage }: InnerProps) => {
  const data = getParallaxData({ layer });
  const backgroundImage = urlLanguageParse(layer.imageUrl ?? '', currentLanguage);

  return (
    <div className={classNames.plx}>
      <Plx parallaxData={data} className={classNames.image} style={{ backgroundImage: `url(${backgroundImage})` }} />
    </div>
  );
};

Parallax.displayName = 'Parallax';

export default withLanguage(Parallax) as ComponentType<OuterProps>;
